import React from 'react';

const HeroBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute inset-0 bg-[#F8F6F3]" />
    {/* Fine warm grid */}
    <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(26,26,24,0.028)_1px,transparent_1px),linear-gradient(to_bottom,rgba(26,26,24,0.028)_1px,transparent_1px)] bg-[size:52px_52px]" />
    {/* Dot overlay */}
    <div className="absolute inset-0 bg-[radial-gradient(rgba(26,26,24,0.048)_1px,transparent_1px)] bg-[size:26px_26px]"
      style={{ maskImage: 'radial-gradient(ellipse 80% 55% at 50% 0%, black 30%, transparent 100%)' }} />
    {/* Red margin line */}
    <div className="absolute top-0 bottom-0 left-[88px] w-px bg-[rgba(220,80,80,0.16)] hidden lg:block" />
    {/* Warm terracotta blob */}
    <div className="absolute top-1/3 left-1/4 w-[480px] h-[320px] bg-[#EDD8C4] rounded-full blur-[130px] opacity-30" />
    {/* Soft sky blue */}
    <div className="absolute top-1/4 right-1/4 w-[360px] h-[360px] bg-[#C8DFF0] rounded-full blur-[110px] opacity-22" />
    <div className="absolute bottom-0 w-full h-56 bg-gradient-to-t from-[#F8F6F3] to-transparent" />
  </div>
);

export default HeroBackground;